module.exports = __webpack_public_path__ + "static/media/2013_nampaCarnival.120a731a.jpg";